import { combineEpics } from "redux-observable";

import { authEpic } from "../features/auth/redux/auth.epic";
import { categoriesEpic } from "../features/categories/redux";
import { countriesEpic } from "../features/countries/redux";
import { dataFieldsEpic } from "../features/data-fields/redux";
import { downloadEpic } from "../features/download/redux/download.epic";
import { gloablsEpic } from "../features/globals/redux/globals.epic";
import { listSearchEpic } from "../features/list-search/redux/list-search.epic";
import { naicsCodesEpic } from "../features/naics-codes/redux";
import { sicCodesEpic } from "../features/sic-codes/redux";
import { statesEpic } from "../features/states/redux";
import { IAction } from "../interface/action.interface";
import { changeLogEpic } from "../pages/change-log/redux/change-log.epic";
import { dataBrowserListEpic } from "../pages/data-browser/redux/lists.epic";
import { faqEpic } from "../pages/faq/redux";
import { homeEpic } from "../pages/home/redux/home.epic";
import { listBuilderPageEpic } from "../pages/list-builder-form/redux/list-builder-form-page.epic";
import { listBuilderTablePageEpic } from "../pages/list-builder-table/redux/list-builder-table-page.epic";
import { listPageEpic } from "../pages/list-page/redux/list-page.epic";
import { trackedListEpic } from "../pages/tracked-lists/redux/tracked-lists.epic";
import { userPreferencesPageEpic } from "../pages/user-preferences/redux/user-preferences.epic";
import { IRootState } from "./root.reducer";

export const rootEpic = combineEpics<IAction, IAction, IRootState>(
    listSearchEpic,
    authEpic,
    homeEpic,
    gloablsEpic,
    downloadEpic,
    listPageEpic,
    sicCodesEpic,
    naicsCodesEpic,
    dataFieldsEpic,
    categoriesEpic,
    dataBrowserListEpic,
    countriesEpic,
    trackedListEpic,
    statesEpic,
    userPreferencesPageEpic,
    listBuilderPageEpic,
    listBuilderTablePageEpic,
    faqEpic,
    changeLogEpic,
);
